import { rgba } from 'polished';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui/theme/tokens';

export const PopoverContainer = styled.div`
	position: absolute;
	background: white;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	margin-bottom: 1px;
	border-radius: 4px;
	filter: drop-shadow(0 2px 4px ${rgba(tokens.border.subtle, 0.5)})
		drop-shadow(0 0px 1px ${rgba(tokens.border.subtle, 1.0)});
	z-index: 6;
`;

export const PopoverArrow = styled.div`
	position: absolute;
	width: 8px;
	height: 8px;
	background: white;
	left: 50%;
	bottom: 0;
	transform: translate(-50%, 50%) rotate(45deg);
`;

export const PopoverContents = styled(Box)`
	position: relative;
	width: 300px;
`;
